import { Icon, IconProps } from '@chakra-ui/react';

export const PotionSvg = ({
  size = 4,
  theme = 'light',
  ...props
}: {
  size?: number;
  theme?: 'light' | 'dark';
} & IconProps): JSX.Element => {
  const color = theme === 'light' ? 'white' : 'black';

  return (
    <Icon
      fill={color}
      height={size}
      viewBox="0 0 14 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.99176 1.99574H8.25892L8.61751 0.618888C8.63617 0.545261 8.63779 0.468339 8.62225 0.393989C8.60671 0.319639 8.57443 0.249825 8.52786 0.18987C8.47943 0.128377 8.41722 0.0791723 8.34627 0.0462389C8.27532 0.0133055 8.19762 -0.00243069 8.11947 0.000304226H5.13121C5.05557 -0.000103948 4.98082 0.0167548 4.91264 0.0496008C4.84447 0.0824468 4.78466 0.130417 4.73776 0.18987C4.69119 0.249825 4.65891 0.319639 4.64338 0.393989C4.62784 0.468339 4.62946 0.545261 4.64811 0.618888L4.99176 1.99574Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09091 6.67826L12.2364 7.8685C12.5618 7.99069 12.839 8.19289 13.0339 8.45021C13.2288 8.70753 13.3329 9.00874 13.3333 9.31679V12.9296C13.3329 13.3485 13.1411 13.7501 12.8 14.0461L11.0848 15.5366C10.7442 15.8329 10.282 15.9996 9.8 16H3.53333C3.05128 15.9996 2.58913 15.8329 2.24848 15.5366L0.533333 14.0461C0.192261 13.7501 0.000424369 13.3485 0 12.9296V9.31679C0.00045958 9.00874 0.104542 8.70753 0.29944 8.45021C0.494339 8.19289 0.771551 7.99069 1.09697 7.8685L4.24242 6.67826L4.45455 5.46696H4.24242C4.08169 5.46696 3.92753 5.41148 3.81387 5.31271C3.70022 5.21394 3.63636 5.07999 3.63636 4.94031V3.36035H9.69697V4.94031C9.69697 5.07999 9.63312 5.21394 9.51946 5.31271C9.4058 5.41148 9.25165 5.46696 9.09091 5.46696H8.87879L9.09091 6.67826ZM6.63285 7.98298C7.00104 7.98298 7.29952 8.28082 7.29952 8.64822V9.97871L8.63285 9.97871C9.00104 9.97871 9.29952 10.2766 9.29952 10.644C9.29952 11.0114 9.00104 11.3092 8.63285 11.3092H7.29952V12.6397C7.29952 13.0071 7.00104 13.3049 6.63285 13.3049C6.26466 13.3049 5.96619 13.0071 5.96619 12.6397V11.3092L4.63285 11.3092C4.26466 11.3092 3.96619 11.0114 3.96619 10.644C3.96619 10.2766 4.26466 9.97871 4.63285 9.97871H5.96619V8.64822C5.96619 8.28082 6.26466 7.98298 6.63285 7.98298Z"
        fill={color}
      />
    </Icon>
  );
};
